<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "FinancialReportLayout"
    }
</script>

<style scoped>

</style>
